define.alias("ember-math-helpers/helpers/acos", "settings/helpers/acos");